import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  shown: boolean
  onClick: () => void
}

export const DashboardOverlay: React.FC<Props> = ({ shown, onClick }) => (
  <div
    className={clsJoin(css.dashboard_overlay, shown && css.shown)}
    onClick={onClick}
  />
)
